import { Box } from '@mui/material';
import React from 'react';
import { JsonLd } from 'react-schemaorg';
import { FAQPage } from 'schema-dts';

import { FAQ as FAQModel } from '../../../models/index';
import { editorJsToSimpleHtml } from '../../utils/editorJsToSimpleHtml';
import { Question } from './components/Question/Question';

export const FAQ: React.FC<FAQModel> = ({ questions, activateStructuredData, displayNumbers }: FAQModel) => {
  if (!questions?.length) {
    return null;
  }

  return (
    <Box>
      {questions.map((element, index) => (
        <Question
          key={element.id}
          id={`${element.__component}.${element.id}`}
          questionNumber={index + 1}
          displayNumbers={displayNumbers}
          {...element}
        />
      ))}
      {activateStructuredData ? (
        <JsonLd<FAQPage>
          item={{
            // eslint-disable-next-line @if6/fi-no-absolute-urls
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: questions.map((element) => {
              return {
                '@type': 'Question',
                name: element.question.text,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: editorJsToSimpleHtml(element.answer.text),
                },
              };
            }),
          }}
        />
      ) : null}
    </Box>
  );
};
